<template>
    <div class="row">
        <div class="col-12">
            <coach-trajectory-enrolments-table
                v-bind="$attrs"
                :columns="columns"
                :filterable="filterable"
            />
        </div>
    </div>
</template>
<script>
    import { CoachTrajectoryEnrolmentsTable } from '~/components/tables'

    export default {
        name: "CoachEnrolmentsTab",

        components: {
            CoachTrajectoryEnrolmentsTable,
        },

        data() {
            return {
                columns: [
                    'name',
                    'city',
                    'status',
                    'active',
                ],
                filterable: ['status'],
            }
        },
    }
</script>
<style scoped></style>